
import { useCustomerFetch } from '@/hooks/admin/useCustomerFetch';
import { useSubscriptionManagement } from '@/hooks/admin/useSubscriptionManagement';
import { useCustomerListState } from '@/hooks/admin/useCustomerListState';
import { CustomerData } from '@/hooks/admin/types';

export type { CustomerData };

export const useCustomerData = () => {
  const { 
    customers, 
    isLoading, 
    error, 
    refreshData, 
    isRefreshing
  } = useCustomerFetch();
  
  const {
    updateCustomerPlan,
    createCustomerSubscription,
    cancelCustomerSubscription
  } = useSubscriptionManagement(refreshData);
  
  const {
    sortedCustomers,
    searchTerm,
    setSearchTerm,
    handleSort,
    sortColumn,
    sortDirection,
    planFilter,
    setPlanFilter,
    customerStats
  } = useCustomerListState(customers);
  
  return { 
    customers: sortedCustomers, 
    isLoading, 
    error,
    searchTerm,
    setSearchTerm,
    handleSort,
    sortColumn,
    sortDirection,
    refreshData,
    isRefreshing,
    updateCustomerPlan,
    createCustomerSubscription,
    cancelCustomerSubscription,
    planFilter,
    setPlanFilter,
    customerStats
  };
};
